import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MonacoEditorModule } from "ngx-monaco-editor-v2";
import { routes } from "./app.routes";
import { authInterceptor } from "./services/auth.interceptor";
import { AuthService } from "./services/auth.service";

function initializeAuth(authService: AuthService) {
  return () => {
    void authService.initialize();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true
    },
    importProvidersFrom(BrowserAnimationsModule),
    importProvidersFrom(
      MonacoEditorModule.forRoot({
        baseUrl: "assets"
      })
    )
  ]
};
